// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fallow-ignore-file */
.jIl55lkk0j9CPQkfjAPx {
  position: relative;
  display: flex;
  align-items: baseline;
  justify-content: center;
  font-family: var(--font-family-secondary, inherit);
  font-weight: 800;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
}
/* Inner, text-only wrapper. Holds prefix + amount + currency so useCampaignCardScale's
   natural-width measurement excludes the SpikedTextFrame spikes (which are siblings of this
   wrapper inside .subtitleContainer). The transform and scaled width live HERE, so only the
   text scales down — the decorative spikes keep their full size. */
.X8izD2xmKYev49saIUUu {
  display: flex;
  align-items: baseline;
  justify-content: center;
  white-space: nowrap;
}
.cKs3igH9fbtoCYXKzyTO {
  color: #efd419;
  text-transform: uppercase;
  text-shadow: var(--campaign-rebate-subtitle-text-shadow, 0px 0px 6px #c9b80050);
  -webkit-text-stroke-color: #ffdb10;
}
.xeDYNaEod2lJ37lHovpp {
  margin-right: 0.2em;
}
.mDgZ3zXQt5CFMFtlnL76 {
  position: relative;
}
/* Cap-alphabetic text-box trim: strips the font's ascent/descent dead space (the amount is
   digits only, so line-height: 1 leaves pure dead air below the glyphs) so the text bottom
   aligns to sibling icons instead of the font box. Both classes are flex items of
   .subtitleContainer, so these margins aren't collapsed away as they would be on a plain inline
   element. Shared, font-metric-derived values — see campaign-variables.module.css. */
.wiPn2r_qmePcPQbNf9iC,
.xeDYNaEod2lJ37lHovpp,
.mDgZ3zXQt5CFMFtlnL76 {
  margin-top: var(--campaign-futura-trim-top);
  margin-bottom: var(--campaign-futura-trim-bottom);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .cKs3igH9fbtoCYXKzyTO {
    text-shadow: var(--campaign-rebate-subtitle-text-shadow-mobile, 0px 0px 4px #c9b80050);
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/shared/RebateSubtitleCampaign/css/base/RebateSubtitleCampaign.base.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;mEAGmE;AACnE;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,+EAA+E;EAC/E,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;;;qFAIqF;AACrF;;;EAGE,2CAA2C;EAC3C,iDAAiD;AACnD;AACA;EACE;IACE,sFAAsF;EACxF;AACF","sourcesContent":["/* fallow-ignore-file */\n.subtitleContainer {\n  position: relative;\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  font-family: var(--font-family-secondary, inherit);\n  font-weight: 800;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n}\n/* Inner, text-only wrapper. Holds prefix + amount + currency so useCampaignCardScale's\n   natural-width measurement excludes the SpikedTextFrame spikes (which are siblings of this\n   wrapper inside .subtitleContainer). The transform and scaled width live HERE, so only the\n   text scales down — the decorative spikes keep their full size. */\n.subtitleTextWrapper {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  white-space: nowrap;\n}\n.subtitleTextStyle {\n  color: #efd419;\n  text-transform: uppercase;\n  text-shadow: var(--campaign-rebate-subtitle-text-shadow, 0px 0px 6px #c9b80050);\n  -webkit-text-stroke-color: #ffdb10;\n}\n.subtitleTextStylePrefix {\n  margin-right: 0.2em;\n}\n.currency {\n  position: relative;\n}\n/* Cap-alphabetic text-box trim: strips the font's ascent/descent dead space (the amount is\n   digits only, so line-height: 1 leaves pure dead air below the glyphs) so the text bottom\n   aligns to sibling icons instead of the font box. Both classes are flex items of\n   .subtitleContainer, so these margins aren't collapsed away as they would be on a plain inline\n   element. Shared, font-metric-derived values — see campaign-variables.module.css. */\n.subtitleTextStyleMain,\n.subtitleTextStylePrefix,\n.currency {\n  margin-top: var(--campaign-futura-trim-top);\n  margin-bottom: var(--campaign-futura-trim-bottom);\n}\n@media (--campaign-mobile) {\n  .subtitleTextStyle {\n    text-shadow: var(--campaign-rebate-subtitle-text-shadow-mobile, 0px 0px 4px #c9b80050);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitleContainer": `jIl55lkk0j9CPQkfjAPx`,
	"subtitleTextWrapper": `X8izD2xmKYev49saIUUu`,
	"subtitleTextStyle": `cKs3igH9fbtoCYXKzyTO`,
	"subtitleTextStylePrefix": `xeDYNaEod2lJ37lHovpp`,
	"currency": `mDgZ3zXQt5CFMFtlnL76`,
	"subtitleTextStyleMain": `wiPn2r_qmePcPQbNf9iC`
};
export default ___CSS_LOADER_EXPORT___;
